import { Tooltip } from '@mui/material'
import Switch from '@mui/material/Switch'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span,
  Copy
} from 'components'
import { DeleteIcon } from 'components/Icons'
import { CopyIcon } from 'components/Icons/CopyIcon'
import moment from 'moment'
import { FORMAT } from 'utils'

interface HandleDeleteContractProps {
  cdContrato: string
  contratoId: number
}

interface ITableSearchContracts {
  tableData: any[]
  handleClickContract: ({ cdContrato, contratoId, dtCadastro, flSap }) => void
  handleDeleteContract: ({
    cdContrato,
    contratoId
  }: HandleDeleteContractProps) => void
  page: number
  setPage: (_page: number) => void
  setRowsPerPage: (_rowsPerPage: number) => void
  rowsPerPage: number
  setPaginationDisabled?: () => boolean
  totalItems: number
}

export const TableSearchContracts = ({
  tableData,
  handleClickContract,
  handleDeleteContract,
  setRowsPerPage,
  setPage,
  page,
  rowsPerPage,
  totalItems,
  setPaginationDisabled
}: ITableSearchContracts) => {
  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="25px" align="center">
                {''}
              </TableCellStyled>
              <TableCellStyled minwidth="20px" >
                Contrato
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align='center'>
                CPF/CNPJ/Cód.Fornecedor
              </TableCellStyled>
              <TableCellStyled minwidth="40px">Fornecedor</TableCellStyled>
              <TableCellStyled minwidth="15px" align="center">Início</TableCellStyled>
              <TableCellStyled minwidth="15px" align="center">Fim</TableCellStyled>
              <TableCellStyled minwidth="10px" align="center">Encerrado</TableCellStyled>
              <TableCellStyled minwidth='70px' align="center">N/A</TableCellStyled>
              <TableCellStyled minwidth="35px" align="center">Empresa</TableCellStyled>
              <TableCellStyled minwidth="150px" align="center">
                Contraparte CSN
              </TableCellStyled>
              <TableCellStyled minwidth="30px" align="center">
                Matrícula
              </TableCellStyled>
              <TableCellStyled minwidth="25px" align='center'>Centro</TableCellStyled>
              <TableCellStyled minwidth="100px" align="center">
                Data Cadastro
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="center">
                SAP
              </TableCellStyled>
              <TableCellStyled minwidth="20px" align="center">
                Deletar
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.length > 0 &&
              tableData?.map((row, index) => {
                if (row.nmCRE == 'N/A') {
                  row.nmCRE = 'SIM';
                } else if (row.nmCRE != 'N/A' && row.nmCRE != 'SIM') {
                  row.nmCRE = 'NÃO';
                }

                const onClick = () =>

                  handleClickContract({
                    cdContrato: row.cdContrato,
                    contratoId: row.contratoId,
                    dtCadastro: row.dtCadastro,
                    // flPrincipal: row.flPrincipal,
                    flSap: row.flSap
                  })

                return (
                  <TableRowStyled key={`${index}-${row.cdContrato}`}>
                    <TableCellStyled align="left">
                      <Copy
                        title="Copiar código do contrato"
                        valueToCopy={row.cdContrato}
                      />
                    </TableCellStyled>
                    <TableCellStyled align="left" onClick={onClick}>
                      <Span
                        text={row.cdContrato}
                        color="#004C97"
                        fontSize="13px"
                        fontWeight="700"
                        marginRight={'7px'}
                      />
                    </TableCellStyled>
                    <TableCellStyled align='center'>
                      {FORMAT.documento(row.cdDocto)}
                    </TableCellStyled>
                    <TableCellStyled>{row.nmFornecedor}</TableCellStyled>
                    <TableCellStyled>{row.dtInicioVigencia}</TableCellStyled>
                    <TableCellStyled>{row.dtFimVigencia}</TableCellStyled>
                    <TableCellStyled align="center">{row.txEncerrado}</TableCellStyled>
                    <TableCellStyled align="center">{row.nmCRE}</TableCellStyled>
                    <TableCellStyled>{row.txDescricao}</TableCellStyled>
                    <TableCellStyled align='center'>{row.nmContraparte}</TableCellStyled>
                    <TableCellStyled align="left">
                      {row.nmMatricula}
                    </TableCellStyled>
                    <TableCellStyled align='center'>{row.txDenominacao}</TableCellStyled>
                    <TableCellStyled align="center">
                      {moment(row?.dtCadastro).format('DD/MM/YYYY') ==
                        '01/01/0001' || !row?.dtCadastro
                        ? '---'
                        : FORMAT.formatDDMMYYYY(row.dtCadastro)}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      {row.flSap ? (
                        <Switch disabled defaultChecked />
                      ) : (
                        <Switch disabled />
                      )}
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <DeleteIcon
                        onClick={() =>
                          handleDeleteContract({
                            cdContrato: row.cdContrato,
                            contratoId: row.contratoId
                          })
                        }
                        cursor="pointer"
                        disabled={row.flSap}
                      />
                    </TableCellStyled>
                  </TableRowStyled>
                )
              })}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        totalItems={totalItems}
        disabled={setPaginationDisabled()}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
